import * as types from './accountPage.types';

export const fetchAccountInfo = params => ({ type: types.FETCH_ACCOUNT_INFO, params });
export const fetchAccountInfoSuccess = data => ({ type: types.FETCH_ACCOUNT_SUCCESS, data });
export const fetchAccountInfoFailure = error => ({ type: types.FETCH_ACCOUNT_FAILURE, error });
